import img1 from '../images/img-collection/collection-1.jpg'
import img2 from '../images/img-collection/collection-2.jpg'
import img3 from '../images/img-collection/collection-3.jpg'
import img4 from '../images/img-collection/collection-4.jpg'
import img5 from '../images/img-collection/collection-5.jpg'
import img6 from '../images/img-collection/collection-6.jpg'
import avt1 from '../images/avatar/avt-3.jpg'
import avt2 from '../images/avatar/avt-4.jpg'
import avt3 from '../images/avatar/avt-5.jpg'
import avt4 from '../images/avatar/avt-6.jpg'
import avt5 from '../images/avatar/avt-7.jpg'
import avt6 from '../images/avatar/avt-8.jpg'

const dataHotCollection = [
    {
        img: img1,
        avt: avt1,
        name: 'Nelson P. Bishos',
        position: 'ERC-75'
    },
    {
        img: img2,
        avt: avt2,
        name: 'Charles Chappell',
        position: 'ERC-75'
    },
    {
        img: img3,
        avt: avt3,
        name: 'Sharles D. Evers',
        position: 'ERC-75'
    },
    {
        img: img4,
        avt: avt4,
        name: 'Bill S. Maxwell',
        position: 'ERC-75'
    },
    {
        img: img5,
        avt: avt5,
        name: 'Nelson P. Bishos',
        position: 'ERC-75'
    },
    {
        img: img6,
        avt: avt6,
        name: 'Lee W. Rodriguez',
        position: 'ERC-75'
    },
    {
        img: img1,
        avt: avt1,
        name: 'Nelson P. Bishos',
        position: 'ERC-75'
    },
    {
        img: img2,
        avt: avt2,
        name: 'Charles Chappell',
        position: 'ERC-75'
    },
    {
        img: img3,
        avt: avt3,
        name: 'Sharles D. Evers',
        position: 'ERC-75'
    },
    {
        img: img4,
        avt: avt4,
        name: 'Bill S. Maxwell',
        position: 'ERC-75'
    },
    {
        img: img5,
        avt: avt5,
        name: 'Nelson P. Bishos',
        position: 'ERC-75'
    },
    {
        img: img6,
        avt: avt6,
        name: 'Lee W. Rodriguez',
        position: 'ERC-75'
    },
]

export default dataHotCollection;